<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                    <path
                        d="M1 7.36857H21.6979M1 7.36857V20.1057C1 20.528 1.16774 20.9329 1.46633 21.2315C1.76491 21.5301 2.16988 21.6979 2.59214 21.6979H20.1057C20.528 21.6979 20.9329 21.5301 21.2315 21.2315C21.5301 20.9329 21.6979 20.528 21.6979 20.1057V7.36857M1 7.36857L3.38821 2.76728C3.64568 2.24867 4.03967 1.81008 4.5278 1.49868C5.01594 1.18729 5.57973 1.01488 6.15854 1H16.5393C17.1317 1.00031 17.7123 1.16588 18.2158 1.47809C18.7192 1.79029 19.1256 2.23676 19.3892 2.76728L21.6979 7.36857M11.3489 1V7.36857M15.3293 14.5332H7.36857"
                        stroke="#44A561" stroke-width="2" stroke-linecap="round" />
                </svg>
            </div>
            <div class="analysisTable__header--title">Venda</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Nome</div>
                            <div class="item__container--value">{{ product }}</div>
                            <div class="item__container--pill green" @click="handleClick()">Ver produto
                            </div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Data da venda</div>
                            <div class="item__container--value">{{ data_pagamento | datetime }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container custom-items">
                            <div class="value">
                                <div class="item__container--title">Valor</div>
                                <div class="item__container--value">{{ valor }}</div>
                            </div>
                            <div class="custom-status" :class="getStatus(status).class">{{ getStatus(status).text }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Método</div>
                            <div class="item__container--value">{{ forma_pagamento }}</div>
                       
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
import Money from '@/src/mixins/money'

export default {
    name: 'AnalysisTableSell',
    mixins: [Money],
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysisSelldata"]
        },
        product() {
            return this.data && this.data.product && this.data.product.name ? this.data.product.name : '---';
        },
        valor() {
            return this.data && this.data.total ? 'R$' + this.data.total.toLocaleString('pt-BR', {maximumFractionDigits: 2, minimumFractionDigits: 2}) : '---';
        },
        status(){
            return this.data && this.data.status ? this.data.status : '';
        },
        data_pagamento() {
            return this.data && this.data.paid_at ? this.data.paid_at : '---';
        },
        forma_pagamento() {
            return this.data && this.data.method && this.data.method === 'CREDIT_CARD' ? 'Cartão de crédito': this.data.method;
        }
    },
    methods: {
        getStatus(status) {
            if (status) {
                switch (status.toLowerCase()) {
                case 'opened': return { text: 'Aberto', class: 'status-sale status-opened' }
                case 'in_negociation': return { text: 'Em negociação', class: 'status-sale status-in-negociation' }
                case 'objection': return { text: 'Objeção', class: 'status-sale status-objection' }
                case 'lost_trading': return { text: 'Negociação Perdida', class: 'status-sale status-lost-trading' }
                case 'win': return { text: 'Vencemos', class: 'status-sale status-win' }
                case '': return { text: 'list', class: 'status-sale status-red' }
                case 'paid': return { text: 'Pago', class: 'status-sale status-paid' }
                case 'waiting_payment': return { text: 'Aguardando pagamento', class: 'status-sale status-pending' }
                case 'abandoned': return { text: 'Abandonado', class: 'status-sale status-abandoned' }
                case 'canceled': return { text: 'Cancelado', class: 'status-sale status-canceled' }
                case 'trialing': return { text: 'Trial', class: 'status-sale status-trialing' }
                case 'pending_approbation': return { text: 'Liberação manual', class: 'status-sale status-pending-approbation' } 
                case 'pending_refund': return { text: 'Reembolso pendente', class: 'status-sale status-pending-refund' }
                case 'refund_pending': return { text: 'Reembolso pendente', class: 'status-sale status-refund-pending' }
                case 'refused': return { text: 'Recusado', class: 'status-sale status-refused' }
                case 'refunded': return { text: 'Reembolsado', class: 'status-sale status-refunded' }
                case 'chargedback': return { text: 'Estorno', class: 'status-sale status-chargedback' }
                case 'delayed': return { text: 'Em processamento', class: 'status-sale status-delayed' }
                case 'created': return { text: 'Criada', class: 'status-sale status-created' }
                default: return { text: status, class: 'status-sale status-default' }
                }
            } else {
                return { text: '', class: 'status-sale status-default' }
            }
        },
        goToMaps() {
            if (this.maps_url) {
                const url = this.maps_url;
                window.open(url, '_blank');
            }
        },
        handleClick() {
            this.$emit('openModalProduct', this.data);
        }
    }
};
</script>

<style scoped lang="scss">
.custom-items{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.custom-items .value,
.custom-items .custom-status{
    flex: 1;
}

.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #44A561;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            .item {
                border-bottom: solid 1px #E5E5E5;
                position: relative;

                &__container {
                    padding: 20px;

                    &--title {
                        color: #B1B1B1;
                        font-size: 0.8em;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }

                    &--value {
                        color: #141414;
                        font-size: 0.9em;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        width: calc(100% - 40px);
                        overflow-x: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    &--pill {
                        position: absolute;
                        right: 20px;
                        top: 30%;
                        width: auto;
                        font-size: 0.7em;
                        padding: 4px 10px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        border-radius: 50px;
                        cursor: pointer;

                    }
                }

            }

            .no-border .item {
                border-bottom: none;
            }

        }
    }
}

.green {
    background: rgba(68, 165, 97, 0.10);
    color: #44A561;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>